module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h14"
  }, [_vm._v("Acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('img', {
    attrs: {
      "alt": "img2.png",
      "src": "images/img2.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "t4"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "t5"
  }, [_vm._v("HIS")]), _c('span', {
    staticClass: "t4"
  }), _c('span', {
    staticClass: "t5"
  }, [_vm._v("BOOK")]), _c('span', {
    staticClass: "t4"
  }), _vm._v("was a long time in the making. I want to thank everyone who supported me throughout the writing of it, especially Carol, who has read who knows how many versions. I also want to thank Sasha for believing in this world. Lastly, I couldn’t do what I do without the support of my family. Love you!")]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1af0d7b3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005.vue
// module id = 66
// module chunks = 0